"use client";

import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyGeolocation } from "./keyGeolocation";
import { geolocationSchema } from "./types/schema/geolocationSchema.schema";

export type UseRequestGeolocationProps = UseRequestQueryProps;

export const useRequestGeolocation = ({
  ...props
}: UseRequestGeolocationProps = {}) => ({
  query: useRequestQuery({
    enabledWithoutSessionToken: true,
    ...props,
    queryFnRequestProps: {
      requestType: "default",
      schema: geolocationSchema,
      urlBackendPath: "/geolocation",
    },
    queryKey: keyGeolocation(),
  }),
});
